const getMoneyFormat = (amount: any) => {
  return `${
    amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }) ?? 0
  }`;
};

export default getMoneyFormat; 